import { render } from "./HorizontalMenu.vue?vue&type=template&id=726a99d0"
import script from "./HorizontalMenu.vue?vue&type=script&lang=js"
export * from "./HorizontalMenu.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__